module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-8-0d2f076b80c33a7e02694506f7b95300.jpg";